export enum StatusCodeEnum {
	BAD_REQUEST = 400,
	FORBIDDEN = 403, // When not logged in
}
